"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SecureDocumentsProvider.default;
  }
});

var _SecureDocumentsProvider = _interopRequireDefault(require("./SecureDocumentsProvider"));

var _SecureDocumentsProvider2 = require("./SecureDocumentsProvider.types");

Object.keys(_SecureDocumentsProvider2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SecureDocumentsProvider2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SecureDocumentsProvider2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9jb250ZXh0L1NlY3VyZURvY3VtZW50c1Byb3ZpZGVyL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBkZWZhdWx0IH0gZnJvbSAnLi9TZWN1cmVEb2N1bWVudHNQcm92aWRlcic7XG5leHBvcnQgKiBmcm9tICcuL1NlY3VyZURvY3VtZW50c1Byb3ZpZGVyLnR5cGVzJztcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/react/context/SecureDocumentsProvider/index.js
// module id = 1812
// module chunks = 0